import { MissionProgressBarStyled } from "./styled";
import { calPercent } from "utils/functions/number";

const MissionProgressBar = ({
  percent = 0,
  gradient,
  bgColor,
  height,
}) => {
  const clamped = calPercent(percent);
  return (
    <MissionProgressBarStyled $trackBg={bgColor} $height={height}>
      <div className="progress_track">
        <div
          className="progress_fill"
          style={{
            width: `${clamped}%`,
            ...(gradient ? { background: gradient } : {}),
          }}
        />
      </div>
    </MissionProgressBarStyled>
  );
};

export default MissionProgressBar;
